import { HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { StringUtils } from '../utils/string.utils';
import { FIELD_LABELS } from '../constants/field-labels.const';
import { ApiError } from '../types/api-error.type';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private msgService = inject(MessageService);

  TOAST_KEY = 'global-toast';
  STICKY = false;

  async showSuccessToast(summary: string, detail: string): Promise<void> {
    this.showToast(summary, detail, 'success');
  }

  async showInfoToast(summary: string, detail: string): Promise<void> {
    this.showToast(summary, detail, 'info');
  }
  async showWarnToast(summary: string, detail: string): Promise<void> {
    this.showToast(summary, detail, 'warn');
  }

  async showErrorToast(summary: string, detail: string): Promise<void> {
    this.showToast(summary, detail, 'error');
  }

  async showApiError(options: {
    notMappedSummary: string;
    notMappedDetail: string;
    mappedApiSummary: string;
    apiError: ApiError;
  }): Promise<void> {
    const errorResponse = options.apiError?.error;
    const statusCode = errorResponse?.statusCode;
    const errorsArray = errorResponse?.errors;

    const isErroMapeado =
      statusCode === HttpStatusCode.ImATeapot ||
      statusCode === HttpStatusCode.Forbidden;

    let mensagemErro = '';

    if (
      Array.isArray(errorsArray) &&
      errorsArray.length > 0 &&
      errorsArray[0]?.message
    ) {
      const primeiroErro = errorsArray[0];
      const path = primeiroErro.path;
      const mensagem = primeiroErro.message;

      if (mensagem) {
        const isErroValidacaoFormulario =
          path && Array.isArray(path) && path.length > 0;

        if (isErroValidacaoFormulario) {
          const campoPath = path[0];
          const nomeCampo =
            FIELD_LABELS[campoPath] || StringUtils.formatarNomeCampo(campoPath);
          mensagemErro = mensagem.replace(
            /^O campo\s+/i,
            `O campo ${nomeCampo} `,
          );
          if (!mensagemErro.includes(nomeCampo)) {
            mensagemErro = `O campo ${nomeCampo} ${mensagem}`;
          }
        } else {
          mensagemErro = mensagem;
        }
      }
    } else if (errorResponse?.message) {
      const temArrayVazio =
        Array.isArray(errorsArray) && errorsArray.length === 0;

      if (isErroMapeado || temArrayVazio) {
        mensagemErro = errorResponse.message;
      }
    }

    if (isErroMapeado) {
      this.showToast(options.mappedApiSummary, mensagemErro || '', 'error');
    } else {
      this.showToast(
        options.notMappedSummary,
        mensagemErro || options.notMappedDetail,
        'error',
      );
    }
  }

  async showToast(
    summary: string,
    detail: string,
    severity: string,
  ): Promise<void> {
    this.msgService.add({
      key: this.TOAST_KEY,
      severity: severity,
      summary: summary,
      detail: detail,
      sticky: this.STICKY,
      life: 3000,
    });
  }
}
